import { ComboboxItem } from '@mantine/core';

import { CustomSelect } from '../../Select';

export interface FilterInputProps {
  label: string;
  value: string | null;
  onChange: (value: string | null, option: ComboboxItem) => void;
  flex?: number;
}

export interface SelectFilterProps extends FilterInputProps {
  description?: string;
  placeholder?: string;

  isDisabled?: boolean;

  options: ComboboxItem[];

  isLoading: boolean;
  isError: boolean;
}

export function SelectFilter(props: SelectFilterProps) {
  const { label, placeholder, description, isDisabled, options, value, onChange, isError, isLoading, flex } = props;

  return (
    <CustomSelect
      data={options}
      value={value}
      onChange={onChange}
      label={label}
      description={description}
      placeholder={placeholder ?? label}
      error={isError ? 'Server error' : null}
      disabled={isDisabled || isLoading}
      flex={flex ?? 1}
      clearable
      searchable
    />
  );
}
